import React, { useState } from "react";
import "./IoTLabExcellence.css";
import PageHeader from "../about/PageHeader";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";

const IoTLabExcellence = () => {
  const [activeSection, setActiveSection] = useState("overview");
  const [activeEventTab, setActiveEventTab] = useState("A.Y 2025-26");
  const [activeHackathonTab, setActiveHackathonTab] = useState("2025");

  /* ---------------- DATA ---------------- */

  const objectives = [
    "To provide a modern, well-equipped laboratory enabling students to learn and experiment with current and emerging technologies.",
    "To upskill learners by imparting new technical knowledge and competencies aligned with industry trends.",
    "To encourage students to design and develop innovative projects using advanced tools and technologies.",
    "To strengthen analytical, problem-solving, and research-oriented thinking among learners.",
    "To create a platform that fosters creativity, innovation, and interdisciplinary collaboration.",
    "To organize workshops, expert sessions, and competitions that enhance hands-on learning experiences.",
    "To promote a research and innovation culture among students and faculty.",
    "To bridge the gap between academic learning and real-world technological applications.",
  ];

  const eventsData = {
    "A.Y 2025-26": [
      {
        name: "Internal Smart India Hackathon",
        date: "19/09/2025",
        details:
          "The Internal Hackathon of TIMSCDR was conducted under Smart India Hackathon 2025. 77 students participated forming 13 teams. Coordinated by Dr. Ashwini Renavikar and judged by Dr. Vivek Bhartiya. The event showcased innovation, teamwork, and problem-solving skills.",
      },
    ],
    "A.Y 2024-25": [
      {
        name: "Workshop On App Development using MATLAB",
        date: "03/02/25 – 04/02/25",
        details:
          "180 students from MCA attended this workshop focusing on application development using MATLAB.",
      },
      {
        name: "IDE Bootcamp",
        date: "23–27/09/2024",
        details:
          "A 5-day Innovation, Design & Entrepreneurship bootcamp at MGM University covering ideation, industrial visits, and prototype building.",
      },
      {
        name: "Internal Smart India Hackathon",
        date: "20/09/2024",
        details:
          "10 students formed 2 teams. Coordinated by Ms. Rohini Bagul. Top teams: Innovators & TechBuild.",
      },
    ],
    "A.Y 2023-24": [
      {
        name: "Power BI & AWS Workshop",
        date: "6–8 Feb 2024",
        details:
          "110 students attended workshop on Power BI and AWS cloud services.",
      },
      {
        name: "IIC Regional Meet",
        date: "06/02/2024",
        details:
          "Held at Pillai HOC College. TIMSCDR team presented innovation initiatives under AICTE/MIC.",
      },
      {
        name: "Smart India Hackathon",
        date: "27/09/2023",
        details:
          "17 students formed 3 teams. Top teams: VaniSudharak, EcoDrops, MaazGroup.",
      },
    ],
    "A.Y 2022-23": [
      {
        name: "E-Waste Hackathon",
        date: "09/05/2023",
        details:
          "Proposed animal shelters using e-waste materials promoting sustainability.",
      },
      {
        name: "Climate Clock Event",
        date: "22/04/2023",
        details:
          "Students assembled climate clocks promoting renewable energy awareness.",
      },
      {
        name: "AWS Workshop",
        date: "7–9 Feb 2023",
        details:
          "160 students attended cloud computing workshop.",
      },
    ],
  };

  const prototypes = [
    {
      title: "Social Distancing ID Card",
      desc: "Maintains social distancing in public places during COVID.",
    },
    {
      title: "Smart Mask",
      desc: "Detects temperature, monitors air pollution, maintains distancing, and reminds usage.",
    },
    {
      title: "Persistence of Vision",
      desc: "Displays messages using LED fan via Bluetooth mobile app.",
    },
    {
      title: "Home Automation",
      desc: "Controls appliances like lights and fans via mobile interface.",
    },
    {
      title: "Arduino Controlled Car",
      desc: "Detects obstacles and automatically changes direction.",
    },
    {
      title: "Automated Irrigation System",
      desc: "Uses soil moisture sensors to automate water pumping.",
    },
    {
      title: "Water Quality Monitoring",
      desc: "Measures temperature, pH, turbidity and evaluates water quality.",
    },
    {
      title: "Air Quality Analyzer",
      desc: "Detects gases like CO & CO2 and indicates safety levels.",
    },
    {
      title: "Motion Sensor & Buzzer",
      desc: "Activates buzzer when motion is detected using PIR sensor.",
    },
  ];

  const workshopsData = [
    { year: "2021-2022", title: "Basic IoT Workshop (online)", date: "11 Feb 2022", participants: "128 (Internal), 2 (External)", desc: "Acquainted with hands-on activities, hardware like Arduino Uno, Tinkercad simulator, and sensor interfacing." },
    { year: "2020-2021", title: "Basic IoT Workshop (online)", date: "16 & 18 Feb 2021", participants: "154 (Internal), 2 (External)", desc: "Arduino environment, Tinkercad simulator, and various IoT project prototypes were demonstrated." },
    { year: "2019-2020", title: "Basic & Adv IoT Workshop", date: "3-7 Feb 2020", participants: "93 (Internal), 2 (External)", desc: "Hardware like Arduino Uno, Ethernet Shield. Interfacing of sensors with Arduino board." },
    { year: "2018-2019", title: "Basic & Adv IoT Workshop", date: "11-15 Feb 2019", participants: "132 (Internal), 3 (External)", desc: "Arduino, Raspberry Pi, Python introduction, Git, GitHub, and AWS IoT." },
    { year: "2017-2018", title: "Basic & Adv IoT Workshop", date: "8-15 Feb 2018", participants: "170 (Internal), 7 (External)", desc: "Hardware like Arduino and Raspberry pi. Technologies covered: Python, Git, AWS IoT." },
    { year: "2016-2017", title: "Basic & Adv IoT Workshop", date: "13-16 Feb 2017", participants: "194 (Internal), 10 (External)", desc: "Arduino environment, Python introduction, AWS IoT." },
    { year: "2015-2016", title: "Basic IoT Workshop", date: "15-18 Feb 2016", participants: "189 Students", desc: "Hands-on activities and hardware like Arduino." },
  ];

  const schoolAwareness = [
    { school: "Samata Vidya Mandir, Kandivali", date: "2 January 2021", participants: "20 students of 8th, 9th and 10th Std." },
    { school: "Ramratna Vidya Mandir, Bhyander", date: "3 August 2019", participants: "50 students of 8, 9 and 11 Std." },
    { school: "Samata Vidya Mandir, Kandivali", date: "26 March 2019", participants: "47 Students of 8 Std." },
    { school: "GCC International School", date: "7th July 2018", participants: "48 Students" },
    { school: "Thakur Public School", date: "17th & 19th January 2018", participants: "116 Students" },
    { school: "Thakur Vidya Mandir High School & Jr College", date: "14th - 16th December 2017", participants: "122 Students" },
  ];

  /* ---------------- UI ---------------- */

  return (
    <>
      <Navbar />

      <div className="ritlL_container">
        <PageHeader
          title="Research Innovation Technology Lab (RITL)"
          crumbs={[{ label: "Home", href: "/" }, { label: "RITL Lab" }]}
        />

        {/* MAIN NAV - Pill Container Style */}
        <div className="ritlL_nav_container">
          <div className="ritlL_tabs">
            {/* Overview Tab */}
            <button
              className={`ritlL_tabBtn ${activeSection === "overview" ? "active" : ""}`}
              onClick={() => setActiveSection("overview")}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ritlL_tab_icon">
                 <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>
              </svg>
              Overview
            </button>

            {/* Activities Tab */}
            <button
              className={`ritlL_tabBtn ${activeSection === "activities" ? "active" : ""}`}
              onClick={() => setActiveSection("activities")}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ritlL_tab_icon">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>
              </svg>
              Activities
            </button>

            {/* Innovation Tab */}
            <button
              className={`ritlL_tabBtn ${activeSection === "innovation" ? "active" : ""}`}
              onClick={() => setActiveSection("innovation")}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ritlL_tab_icon">
                 <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
              Innovation
            </button>

            {/* Outreach Tab */}
            <button
              className={`ritlL_tabBtn ${activeSection === "outreach" ? "active" : ""}`}
              onClick={() => setActiveSection("outreach")}
            >
               <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ritlL_tab_icon">
                 <circle cx="12" cy="12" r="3"></circle><circle cx="19" cy="5" r="2"></circle><circle cx="5" cy="5" r="2"></circle><circle cx="19" cy="19" r="2"></circle><circle cx="5" cy="19" r="2"></circle><path d="M6.5 6.5L10.5 10.5"></path><path d="M17.5 6.5L13.5 10.5"></path><path d="M6.5 17.5L10.5 13.5"></path><path d="M17.5 17.5L13.5 13.5"></path>
               </svg>
              Outreach
            </button>
          </div>
        </div>

        {/* ---------------- OVERVIEW ---------------- */}
        {activeSection === "overview" && (
          <section className="ritlL_section">
            <p className="ritlL_intro_text">
              The institute operated an IoT Excellence Lab that primarily focused on training and projects related to the Internet of Things. To expand its scope and align with emerging technologies, the lab was restructured and rebranded as the <strong className="ritlL_highlight">Research Innovation Technology Lab (RITL)</strong>. The RITL aims to create a dynamic learning environment that promotes research, innovation, and skill development across multiple domains of modern technology, including AI, data analytics, and smart systems.
            </p>

            <div className="ritlL_overview_grid">
              
              {/* LEFT CARD: Objectives */}
              <div className="ritlL_overview_card">
                <div className="ritlL_card_header">
                  <div className="ritlL_card_icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>
                  </div>
                  <h2 className="ritlL_card_title">Objectives of RITL</h2>
                </div>
                
                <ul className="ritlL_custom_list">
                  {objectives.map((obj, i) => (
                    <li key={i}>
                      <svg className="ritlL_check_icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                      <span>{obj}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* RIGHT CARD: Skillset */}
              <div className="ritlL_overview_card">
                <div className="ritlL_card_header">
                  <div className="ritlL_card_icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line></svg>
                  </div>
                  <h2 className="ritlL_card_title">Skillset Development for IoT</h2>
                </div>
                
                <div className="ritlL_card_body_centered">
                  <svg viewBox="0 0 500 300" className="ritlL_iot_img" style={{ width: '100%', maxWidth: '420px' }}>
                    <defs>
                      <linearGradient id="iotCloudGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#8EA1FF" />
                        <stop offset="100%" stopColor="#5865F2" />
                      </linearGradient>
                      <filter id="cloudShadow" x="-20%" y="-20%" width="140%" height="140%">
                        <feDropShadow dx="0" dy="8" stdDeviation="12" floodColor="#5865F2" floodOpacity="0.25" />
                      </filter>
                    </defs>
                    <g stroke="#8EA1FF" strokeWidth="2" strokeDasharray="6,6" opacity="0.6">
                      <line x1="250" y1="150" x2="250" y2="35" /> 
                      <line x1="250" y1="150" x2="390" y2="75" /> 
                      <line x1="250" y1="150" x2="440" y2="150" /> 
                      <line x1="250" y1="150" x2="390" y2="225" /> 
                      <line x1="250" y1="150" x2="250" y2="265" /> 
                      <line x1="250" y1="150" x2="110" y2="225" /> 
                      <line x1="250" y1="150" x2="60" y2="150" /> 
                      <line x1="250" y1="150" x2="110" y2="75" /> 
                    </g>
                    <path d="M170 160 Q140 160 140 130 Q140 110 160 100 Q170 60 230 60 Q280 60 300 90 Q330 90 350 110 Q370 130 350 160 Z" fill="url(#iotCloudGradient)" filter="url(#cloudShadow)"/>
                    <text x="245" y="125" fill="#FFFFFF" fontSize="42" fontWeight="800" fontFamily="sans-serif" textAnchor="middle" dominantBaseline="middle">IoT</text>
                    <g fill="#FFFFFF" stroke="#5865F2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="250" cy="35" r="22" stroke="none" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))"/><circle cx="250" cy="35" r="22" fill="none" strokeWidth="1.5" stroke="#E2E8F0" /><path d="M238 32 A 14 14 0 0 1 262 32 M243 37 A 8 8 0 0 1 257 37 M248 42 A 2 2 0 0 1 252 42" fill="none" />
                      <circle cx="390" cy="75" r="22" stroke="none" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))"/><circle cx="390" cy="75" r="22" fill="none" strokeWidth="1.5" stroke="#E2E8F0" /><rect x="382" y="62" width="16" height="26" rx="3" fill="none" /><line x1="388" y1="84" x2="392" y2="84" />
                      <circle cx="440" cy="150" r="22" stroke="none" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))"/><circle cx="440" cy="150" r="22" fill="none" strokeWidth="1.5" stroke="#E2E8F0" /><rect x="431" y="148" width="18" height="12" rx="2" fill="none" /><path d="M435 148 V142 A 5 5 0 0 1 445 142 V148" fill="none" />
                      <circle cx="390" cy="225" r="22" stroke="none" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))"/><circle cx="390" cy="225" r="22" fill="none" strokeWidth="1.5" stroke="#E2E8F0" /><rect x="380" y="215" width="20" height="20" rx="4" fill="none" /><path d="M384 215 V210 M396 215 V210 M384 235 V240 M396 235 V240" fill="none" />
                      <circle cx="250" cy="265" r="22" stroke="none" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))"/><circle cx="250" cy="265" r="22" fill="none" strokeWidth="1.5" stroke="#E2E8F0" /><circle cx="250" cy="265" r="6" fill="none" /><path d="M250 253 V249 M250 281 V277 M238 265 H234 M266 265 H262 M241 256 L238 253 M262 277 L259 274 M259 256 L262 253 M238 277 L241 274" />
                      <circle cx="110" cy="225" r="22" stroke="none" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))"/><circle cx="110" cy="225" r="22" fill="none" strokeWidth="1.5" stroke="#E2E8F0" /><path d="M100 216 L110 212 L120 216 V224 C120 230 110 236 110 236 C110 236 100 230 100 224 Z" fill="none" />
                      <circle cx="60" cy="150" r="22" stroke="none" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))"/><circle cx="60" cy="150" r="22" fill="none" strokeWidth="1.5" stroke="#E2E8F0" /><rect x="49" y="142" width="22" height="16" rx="2" fill="none" /><circle cx="60" cy="150" r="4" fill="none" />
                      <circle cx="110" cy="75" r="22" stroke="none" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))"/><circle cx="110" cy="75" r="22" fill="none" strokeWidth="1.5" stroke="#E2E8F0" /><rect x="98" y="63" width="24" height="6" rx="1" fill="none" /><rect x="98" y="72" width="24" height="6" rx="1" fill="none" /><rect x="98" y="81" width="24" height="6" rx="1" fill="none" />
                    </g>
                  </svg>
                  <p>The institute has signed a MoU with M/S Makerville Solutions (OPC) Pvt Ltd for imparting IoT skillset to students and to develop and deliver industry standard IoT Projects.</p>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* ---------------- ACTIVITIES ---------------- */}
        {activeSection === "activities" && (
          <section className="ritlL_section ritlL_activities_card">
            
            {/* Events Header with Dotted Line */}
            <div className="ritlL_act_header_row">
              <div className="ritlL_act_header_icon">
                {/* Calendar Icon */}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
              </div>
              <h2 className="ritlL_act_heading">Events</h2>
              <div className="ritlL_act_dotted_line"></div>
            </div>

            {/* Year Pill Tabs */}
            <div className="ritlL_year_tabs">
              {Object.keys(eventsData).map((year) => (
                <button
                  key={year}
                  className={`ritlL_year_btn ${activeEventTab === year ? "active" : ""}`}
                  onClick={() => setActiveEventTab(year)}
                >
                  {year}
                </button>
              ))}
            </div>

            {/* Events Table */}
            <div className="ritlL_act_table_wrapper">
              <table className="ritlL_act_table">
                <thead>
                  <tr>
                    <th width="10%">SR. NO.</th>
                    <th width="25%">EVENT NAME</th>
                    <th width="15%">DATE</th>
                    <th>DETAILS</th>
                  </tr>
                </thead>
                <tbody>
                  {eventsData[activeEventTab].map((e, i) => (
                    <tr key={i}>
                      <td className="ritlL_sr_col"><strong>{i + 1}</strong></td>
                      <td><strong className="ritlL_event_title">{e.name}</strong></td>
                      <td>
                        <span className="ritlL_date_col">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                          {e.date}
                        </span>
                      </td>
                      <td className="ritlL_desc_text">{e.details}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Workshops Header with Dotted Line */}
            <div className="ritlL_act_header_row" style={{ marginTop: "60px" }}>
              <div className="ritlL_act_header_icon">
                {/* Clipboard / Workshop Icon */}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect><line x1="9" y1="14" x2="15" y2="14"></line><line x1="9" y1="18" x2="15" y2="18"></line><line x1="9" y1="10" x2="9.01" y2="10"></line></svg>
              </div>
              <h2 className="ritlL_act_heading">IoT Workshops Conducted at TIMSCDR</h2>
              <div className="ritlL_act_dotted_line"></div>
            </div>

            {/* Workshops Table */}
            <div className="ritlL_act_table_wrapper">
              <table className="ritlL_act_table">
                <thead>
                  <tr>
                    <th width="10%">YEAR</th>
                    <th width="20%">WORKSHOP</th>
                    <th width="15%">DATE</th>
                    <th width="20%">PARTICIPANTS</th>
                    <th>DESCRIPTION</th>
                  </tr>
                </thead>
                <tbody>
                  {workshopsData.map((w, i) => (
                    <tr key={i}>
                      <td className="ritlL_sr_col"><strong>{w.year}</strong></td>
                      <td className="ritlL_workshop_title">{w.title}</td>
                      <td>
                        <span className="ritlL_date_col">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                          {w.date}
                        </span>
                      </td>
                      <td className="ritlL_desc_text">{w.participants}</td>
                      <td className="ritlL_desc_text">{w.desc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        )}

        {/* ---------------- INNOVATION ---------------- */}
        {activeSection === "innovation" && (
          <section className="ritlL_section ritlL_activities_card">
            
            {/* Hackathons Header */}
            <div className="ritlL_act_header_row">
              <div className="ritlL_act_header_icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
              </div>
              <h2 className="ritlL_act_heading">Hackathons</h2>
              <div className="ritlL_act_dotted_line"></div>
            </div>

            <div className="ritlL_year_tabs">
              {["2025", "2024"].map((year) => (
                <button
                  key={year}
                  className={`ritlL_year_btn ${activeHackathonTab === year ? "active" : ""}`}
                  onClick={() => setActiveHackathonTab(year)}
                >
                  {year}
                </button>
              ))}
            </div>

            {/* 2025 Table */}
            {activeHackathonTab === "2025" && (
              <>
                <p className="ritlL_desc_text" style={{ marginBottom: "20px" }}>
                  <strong>ICAIM Pre-Conference Hackathon 2025</strong> focused on "Driving Changes in Education, Health, and Agriculture Using AI" with 86 participants.
                </p>

                <div className="ritlL_act_table_wrapper" style={{marginBottom: '40px'}}>
                  <table className="ritlL_act_table">
                    <thead>
                      <tr>
                        <th width="10%">SR. NO.</th>
                        <th width="40%">PROJECT TITLE</th>
                        <th>WINNING ROLL NUMBERS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td className="ritlL_sr_col"><strong>1</strong></td><td><strong className="ritlL_event_title">Next Gen Diagnostics</strong></td><td className="ritlL_desc_text">05,08,10,24,25,33,49,51,53,59</td></tr>
                      <tr><td className="ritlL_sr_col"><strong>2</strong></td><td><strong className="ritlL_event_title">Sign Language Recognition</strong></td><td className="ritlL_desc_text">12,45,46,50,54,58,61,62,63,21</td></tr>
                      <tr><td className="ritlL_sr_col"><strong>3</strong></td><td><strong className="ritlL_event_title">Lung Cancer Detection</strong></td><td className="ritlL_desc_text">86,190,192,195,198,202,211,219,229,232</td></tr>
                      <tr><td className="ritlL_sr_col"><strong>4</strong></td><td><strong className="ritlL_event_title">Stock Price Prediction (ML)</strong></td><td className="ritlL_desc_text">175,147,137,154,153,148,209,213</td></tr>
                      <tr><td className="ritlL_sr_col"><strong>5</strong></td><td><strong className="ritlL_event_title">Plant Disease Detection (CNN)</strong></td><td className="ritlL_desc_text">101,70,76,79,100,105,106,107,117,27</td></tr>
                      <tr><td className="ritlL_sr_col"><strong>6</strong></td><td><strong className="ritlL_event_title">Precision Agriculture Meets Biotech</strong></td><td className="ritlL_desc_text">235,87,141,32,210,235,238,231</td></tr>
                      <tr><td className="ritlL_sr_col"><strong>7</strong></td><td><strong className="ritlL_event_title">AgroShield</strong></td><td className="ritlL_desc_text">170,180,177,173,178,152,174,183,164,169</td></tr>
                      <tr><td className="ritlL_sr_col"><strong>8</strong></td><td><strong className="ritlL_event_title">AI Handwritten Text Converter</strong></td><td className="ritlL_desc_text">9,15,17,18,37,38,40</td></tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* 2024 Table */}
            {activeHackathonTab === "2024" && (
              <>
                <p className="ritlL_desc_text" style={{ marginBottom: "20px" }}>
                  <strong>ICAIM 2024 Internal Hackathon</strong> focused on Women Empowerment. Sponsored by D-Link.
                </p>

                <div className="ritlL_act_table_wrapper" style={{marginBottom: '40px'}}>
                  <table className="ritlL_act_table">
                    <thead>
                      <tr>
                        <th width="20%">POSITION</th>
                        <th>STUDENTS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="ritlL_sr_col"><strong>1st Winner</strong></td>
                        <td className="ritlL_desc_text">
                          Asif Samani, Pratik Shukla, Sanjana Yadav, Sanyog Yadav,
                          Aniket Gupta, Mohamed Afzal Nandolia
                        </td>
                      </tr>
                      <tr>
                        <td className="ritlL_sr_col"><strong>2nd Winner</strong></td>
                        <td className="ritlL_desc_text">
                          Aditya Mayekar, Shubham Kandarkar, Yash Mewada, Sonam Chaudhary
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* Prototypes Header */}
            <div className="ritlL_act_header_row" style={{ marginTop: "60px" }}>
              <div className="ritlL_act_header_icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>
              </div>
              <h2 className="ritlL_act_heading">Prototypes Developed</h2>
              <div className="ritlL_act_dotted_line"></div>
            </div>

            {/* Prototypes Table */}
            <div className="ritlL_act_table_wrapper">
              <table className="ritlL_act_table">
                <thead>
                  <tr>
                    <th width="10%">SR. NO.</th>
                    <th width="25%">PROTOTYPE NAME</th>
                    <th>DETAILS / DESCRIPTION</th>
                  </tr>
                </thead>
                <tbody>
                  {prototypes.map((p, i) => (
                    <tr key={i}>
                      <td className="ritlL_sr_col"><strong>{i + 1}</strong></td>
                      <td><strong className="ritlL_event_title">{p.title}</strong></td>
                      <td className="ritlL_desc_text">{p.desc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        )}

        {/* ---------------- OUTREACH ---------------- */}
        {activeSection === "outreach" && (
          <section className="ritlL_section ritlL_activities_card">
            
            {/* Outreach Header */}
            <div className="ritlL_act_header_row">
              <div className="ritlL_act_header_icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><circle cx="19" cy="5" r="2"></circle><circle cx="5" cy="5" r="2"></circle><circle cx="19" cy="19" r="2"></circle><circle cx="5" cy="19" r="2"></circle><path d="M6.5 6.5L10.5 10.5"></path><path d="M17.5 6.5L13.5 10.5"></path><path d="M6.5 17.5L10.5 13.5"></path><path d="M17.5 17.5L13.5 13.5"></path></svg>
              </div>
              <h2 className="ritlL_act_heading">IoT Awareness Program for Schools</h2>
              <div className="ritlL_act_dotted_line"></div>
            </div>
            
            <p className="ritlL_desc_text" style={{ marginBottom: "24px" }}>
              <strong>Objectives:</strong> To enable students to contribute towards society by creating IoT awareness among school students and improve their technical and communication skills.<br/><br/>
              <strong>Event Description:</strong> The training program was conducted by TIMSCDR faculty members and student IoT team in Various Schools. It covered basics of IoT along with project demos (Arduino Car, Home Automation) and hands-on sessions (LED Blinking, Sensors).
            </p>

            {/* Outreach Table */}
            <div className="ritlL_act_table_wrapper" style={{marginBottom: '60px'}}>
              <table className="ritlL_act_table">
                <thead>
                  <tr>
                    <th width="10%">SR. NO.</th>
                    <th width="35%">NAME OF SCHOOL</th>
                    <th width="20%">EVENT DATE</th>
                    <th>PARTICIPANTS</th>
                  </tr>
                </thead>
                <tbody>
                  {schoolAwareness.map((item, i) => (
                    <tr key={i}>
                      <td className="ritlL_sr_col"><strong>{i + 1}</strong></td>
                      <td><strong className="ritlL_event_title">{item.school}</strong></td>
                      <td>
                        <span className="ritlL_date_col">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                          {item.date}
                        </span>
                      </td>
                      <td className="ritlL_desc_text">{item.participants}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Gallery Header */}
            <div className="ritlL_act_header_row">
              <div className="ritlL_act_header_icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
              </div>
              <h2 className="ritlL_act_heading">Lab Gallery</h2>
              <div className="ritlL_act_dotted_line"></div>
            </div>

            <div className="ritlL_gallery" style={{ marginTop: "24px" }}>
              <img src="/images/lab1.jpg" alt="lab" />
              <img src="/images/lab2.jpg" alt="lab" />
              <img src="/images/lab3.jpg" alt="lab" />
            </div>
          </section>
        )}
      </div>

      <Footer />
    </>
  );
};

export default IoTLabExcellence;